import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		id: 'navigation-next.navigation-views.root.common.settings',
		defaultMessage: 'Jira settings',
		description: 'Navigation item which links to a Jira global settings page',
	},
	system: {
		id: 'navigation-next.navigation-views.root.global-settings.home.system',
		defaultMessage: 'System',
		description: 'Navigation item which links to a system settings page',
	},
	applications: {
		id: 'navigation-next.navigation-views.root.global-settings.home.applications',
		defaultMessage: 'Products',
		description: 'Navigation item which links to an applications settings page',
	},
	projects: {
		id: 'navigation-next.navigation-views.root.global-settings.home.projects',
		defaultMessage: 'Projects',
		description: 'Navigation item which links to a projects settings page',
	},
	issues: {
		id: 'navigation-next.navigation-views.root.global-settings.home.issues',
		defaultMessage: 'Issues',
		description: 'Navigation item which links to an issues settings page',
	},
	addons: {
		id: 'navigation-next.navigation-views.root.global-settings.home.addons',
		defaultMessage: 'Apps',
		description: 'Navigation item which links to an apps settings page',
	},
	recommendations: {
		id: 'navigation-next.navigation-views.root.global-settings.home.recommendations',
		defaultMessage: 'Recommendations',
		description: 'Navigation item which links to the recommendation apps',
	},
	userManagement: {
		id: 'navigation-next.navigation-views.root.global-settings.home.user-management',
		defaultMessage: 'User management',
		description: 'Navigation item which links to a user management settings page',
	},
	billing: {
		id: 'navigation-next.navigation-views.root.global-settings.home.billing',
		defaultMessage: 'Billing',
		description: 'Navigation item which links to a billing settings page',
	},
	discoverApplications: {
		id: 'navigation-next.navigation-views.root.global-settings.home.discover-applications',
		defaultMessage: 'Discover applications',
		description: 'Navigation item which links to a discover applications settings page',
	},
	jiraSettingsCommandPaletteMac: {
		id: 'navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac',
		defaultMessage:
			'<strong>Tip:</strong> Try <wrapper><command>⌘</command><key>K</key></wrapper> to search Jira settings',
		description:
			'Tip message next to Jira settings heading advising settings can be found on the command Palette. This message will be displayed on Mac OS only.',
	},
	jiraSettingsCommandPaletteOther: {
		id: 'navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other',
		defaultMessage:
			'<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings',
		description:
			'Tip message next to Jira settings heading advising settings can be found on the command Palette. This message will be displayed on not Mac OS computers.',
	},
	jiraSettingsCommandPaletteMacScreenReader: {
		id: 'navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader',
		defaultMessage: 'Tip: Try command K to search Jira settings',
		description:
			'This message is going to be set on the `aria-label` of the tip message to be read by screen readers only. "command" refers to the key ⌘',
	},
	jiraSettingsCommandPaletteOtherScreenReader: {
		id: 'navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader',
		defaultMessage: 'Tip: Try control K to search Jira settings',
		description:
			'This message is going to be set on the `aria-label` of the tip message to be read by screen readers only. "control" refers to the key Ctrl of the keyboard',
	},
	'site-admin': {
		id: 'navigation-apps.settings-drawer.section.site-admin',
		defaultMessage: 'Atlassian admin',
		description: 'Title of the list of links to site administration pages',
	},
	'system-admin': {
		id: 'navigation-apps.settings-drawer.section.system-admin',
		defaultMessage: 'Jira settings',
		description: 'Title of the list of links to jira administration pages',
	},
	'ops-admin': {
		id: 'navigation-apps.settings-drawer.section.ops-admin',
		defaultMessage: 'Jira settings',
		description: 'Title of the list of links to jira administration pages',
	},
	'trusted-user': {
		id: 'navigation-apps.settings-drawer.section.trusted-user',
		defaultMessage: 'Atlassian admin',
		description: 'Title of the list of links to administration pages for trusted user',
	},
	'personal-settings': {
		id: 'navigation-apps.settings-drawer.section.personal-settings',
		defaultMessage: 'Personal settings',
		description: 'Title of personal settings section on top navigation bar',
	},
	'admin-system-menu': {
		id: 'navigation-apps.settings-drawer.section.item.admin-system-menu',
		defaultMessage:
			'Manage your general configuration, global permissions, look and feel and more.',
		description: 'Description for navigation item which links to a system settings page',
	},
	'admin-applications-menu': {
		id: 'navigation-apps.settings-drawer.section.item.admin-applications-menu',
		defaultMessage: "Manage your Jira products' settings and integrations.",
		description: 'Description for navigation item which links to an applications settings page',
	},
	'admin-manage-project-menu': {
		id: 'navigation-apps.settings-drawer.section.item.admin-manage-project-menu',
		defaultMessage: 'Manage your project settings, categories, and more.',
		description: 'Description for navigation item which links to a manage projects page',
	},
	'admin-issues-menu': {
		id: 'navigation-apps.settings-drawer.section.item.admin-issues-menu',
		defaultMessage: 'Configure your issue types, workflows, screens, custom fields and more.',
		description: 'Description for navigation item which links to an issues settings page',
	},
	'admin-issues-menu-issue-term-refresh': {
		id: 'navigation-apps.settings-drawer.section.item.admin-issues-menu-issue-term-refresh',
		defaultMessage: 'Configure your work types, workflows, screens, custom fields and more.',
		description: 'Description for navigation item which links to an issues settings page',
	},
	'admin-plugins-menu': {
		id: 'navigation-apps.settings-drawer.section.item.admin-plugins-menu',
		defaultMessage: 'Add and manage Jira Marketplace apps.',
		description: 'Description for navigation item which links to an apps settings page',
	},
	'user-management-section': {
		id: 'navigation-apps.settings-drawer.section.item.user-management-section',
		defaultMessage: 'Add users, groups, and manage access requests.',
		description: 'Description for navigation item which links to a user management settings page',
	},
	'admin-billing-section': {
		id: 'navigation-apps.settings-drawer.section.item.admin-billing-section',
		defaultMessage: 'Update your billing details, manage your subscriptions and more.',
		description: 'Description for navigation item which links to a billing settings page',
	},
	'trusted-admin-user-management-section': {
		id: 'navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section',
		defaultMessage: 'Invite users to your site.',
		description: 'Description for navigation item which links to a invite users page',
	},
	'discover-applications-section': {
		id: 'navigation-apps.settings-drawer.section.item.discover-applications-section',
		defaultMessage: 'Try more Atlassian products.',
		description: 'Description for navigation item which links to a discover applications page',
	},
	// NAV4 Messages
	personalJiraSettingsNonFinal: {
		defaultMessage: 'Personal Jira settings',
		id: 'atlassian-navigation-nav4.common.settings-content.personal-jira-settings-non-final',
		description: 'Heading for Jira user settings dropdown group',
	},
	jiraAdminSettingsNonFinal: {
		defaultMessage: 'Jira admin settings',
		id: 'atlassian-navigation-nav4.common.settings-content.jira-admin-settings-non-final',
		description: 'Heading for the Jira admin settings dropdown group',
	},
	systemDescriptionNonFinal: {
		defaultMessage: 'Manage general configuration, security, automation, user interface, and more',
		id: 'atlassian-navigation-nav4.common.settings-content.system-description-non-final',
		description: 'Description for the System dropdown item',
	},
	productsDescriptionNonFinal: {
		defaultMessage: "Manage Jira products' access, settings, and integrations",
		id: 'atlassian-navigation-nav4.common.settings-content.products-description-non-final',
		description: 'Description for the Products dropdown item',
	},
	projectsDescriptionNonFinal: {
		defaultMessage: 'Manage project settings, categories, and more',
		id: 'atlassian-navigation-nav4.common.settings-content.projects-description-non-final',
		description: 'Description for the Projects dropdown item',
	},
	issuesDescriptionNonFinal: {
		defaultMessage: 'Configure issue types, workflows, screens, fields, and more',
		id: 'atlassian-navigation-nav4.common.settings-content.issues-description-non-final',
		description: 'Description for the Issues dropdown item',
	},
	appsDescriptionNonFinal: {
		defaultMessage: 'Add and manage Jira Marketplace apps and integrations',
		id: 'atlassian-navigation-nav4.common.settings-content.apps-description-non-final',
		description: 'Description for the Apps dropdown item',
	},
	atlassianAdminSettingsNonFinal: {
		defaultMessage: 'Atlassian admin settings',
		id: 'atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings-non-final',
		description: 'Heading for the Atlassian admin settings dropdown group',
	},
	userManagementDescriptionNonFinal: {
		defaultMessage: 'Manage users, groups, and access requests',
		id: 'atlassian-navigation-nav4.common.settings-content.user-management-description-non-final',
		description: 'Description for the User management dropdown item',
	},
	billingDescriptionNonFinal: {
		defaultMessage: 'Update your billing details, manage subscriptions, and more',
		id: 'atlassian-navigation-nav4.common.settings-content.billing-description-non-final',
		description: 'Description for the Billing dropdown item',
	},
	issuesIssueTermRefresh: {
		id: 'navigation-next.navigation-views.root.global-settings.home.issues-issue-term-refresh',
		defaultMessage: 'Work items',
		description: 'Navigation item which links to an issues settings page',
	},
	issuesDescriptionNonFinalIssueTermRefresh: {
		defaultMessage: 'Configure work types, workflows, screens, fields, and more',
		id: 'atlassian-navigation-nav4.common.settings-content.issues-description-non-final-issue-term-refresh',
		description: 'Description for the Issues dropdown item',
	},
});
